import { useDialog } from "@shared/features/dialog/useDialog";
import { MarketingDialogTypes } from "@platform/types/platform.types";
import { NewsletterDialog } from "../NewsletterDialog/NewsletterDialog";
import { HireUsDialog } from "../HireUsDialog/HireUsDialog";
import { AddYourInstitutionDialog } from "../AddYourInstitutionDialog/AddYourInstitutionDialog";
import { OrgCodeDialog } from "../../../orgInvitation/components/OrgCodeDialog/OrgCodeDialog";
import { OrgLookupDialog } from "../../../orgInvitation/components/OrgLookupDialog/OrgLookupDialog";

export function MarketingDialogs() {
  const { activeDialog } = useDialog();

  if (
    ![
      "code",
      "orgLookup",
      "hireUs",
      "newsletter",
      "addYourInstitution",
    ].includes(activeDialog || "")
  ) {
    return null;
  }

  switch (activeDialog as MarketingDialogTypes) {
    case "code":
      return <OrgCodeDialog />;
    case "orgLookup":
      return <OrgLookupDialog />;
    case "hireUs":
      return <HireUsDialog />;
    case "newsletter":
      return <NewsletterDialog />;
    case "addYourInstitution":
      return <AddYourInstitutionDialog />;
    default:
      return null;
  }
}
